import { render } from "./scoreStart.vue?vue&type=template&id=45ebe688&scoped=true"
import script from "./scoreStart.vue?vue&type=script&lang=js"
export * from "./scoreStart.vue?vue&type=script&lang=js"

import "./scoreStart.vue?vue&type=style&index=0&id=45ebe688&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ebe688"]])

export default __exports__